import { call, put, takeLatest } from 'redux-saga/effects';
import invokeApi from '../network';
import networkConfig from '../network/config';
import { POST_ORDER_ACCEPTED, POST_ORDER_ACCEPTED_ERROR, POST_ORDER_ACCEPTED_SUCCESS, CANCEL_POST_ORDER, CANCEL_POST_ORDER_ERROR, CANCEL_POST_ORDER_SUCCESS, CHECK_IN_REQUEST, CHECK_IN_REQUEST_ERROR, CHECK_IN_REQUEST_SUCCESS, FETCH_CASH_TRANSCATION_ID_SUCCESS, FETCH_CASH_TRANSCATION_ID_FAILURE, FETCH_CASH_TRANSCATION_ID, ADD_HOPE_PAY_ACCEPTED_SUCCESS, ADD_HOPE_PAY_ACCEPTED_FAILURE, ADD_HOPE_PAY_ACCEPTED, GIFT_CARD_PURCHASE, GIFT_CARD_PURCHASE_SUCCESS, GIFT_CARD_PURCHASE_ERROR } from '../constants';
import { setErrorCode } from '../redux/Actions/ErrorAction';
import AuthManager from '../auth/AuthManager';
import Strings from '../constants/Strings';
const { getInstance: auth } = AuthManager;
export function* orderAcceptedCall(data) {
    const { payload, successCallback, errorCallback } = data;
    const { orderId, tenantId, customerId } = payload;
    const headers = {
        'x-tenant-id': tenantId,
        'x-is-registered-user': auth().isMember,
        'x-user-id': customerId,
        'Content-Type': 'application/json',
    };
    try {
        const { response, status } = yield call(invokeApi, networkConfig.postOrderAccepted, { queryProps: { orderId: orderId } }, headers);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response) {
            yield put({
                type: POST_ORDER_ACCEPTED_SUCCESS,
                response,
            });
            successCallback && successCallback(response);
        }
        else {
            yield put({
                type: POST_ORDER_ACCEPTED_ERROR,
            });
            errorCallback && errorCallback();
        }
    }
    catch (error) {
        yield put({
            type: POST_ORDER_ACCEPTED_ERROR,
        });
        errorCallback && errorCallback();
    }
}
export function* fetchCashTransactionCall(data) {
    const { payload } = data;
    const { orderId, tenantId, customerId } = payload;
    const headers = {
        'x-tenant-id': tenantId,
        'x-is-registered-user': auth().isMember,
        'x-user-id': customerId,
    };
    const item = {
        orderId: orderId,
        tenderType: Strings.payByCash,
        additionalAttributes: {},
    };
    try {
        const { response, status } = yield call(invokeApi, networkConfig.cashTransactionId, null, headers, item);
        if (response.transactionId) {
            yield put({
                type: FETCH_CASH_TRANSCATION_ID_SUCCESS,
                response,
            });
        }
        else {
            yield put({
                type: FETCH_CASH_TRANSCATION_ID_FAILURE,
            });
        }
    }
    catch (error) {
        yield put({
            type: FETCH_CASH_TRANSCATION_ID_FAILURE,
        });
    }
}
export function* fetchCashTranscationIdSaga() {
    yield takeLatest(FETCH_CASH_TRANSCATION_ID, fetchCashTransactionCall);
}
export function* orderAcceptedSaga() {
    yield takeLatest(POST_ORDER_ACCEPTED, orderAcceptedCall);
}
export function* cancelPostOrderCall(data) {
    const { payload, successCallback, errorCallback } = data;
    const { orderId, tenantId, customerId, paramData } = payload;
    const headers = {
        'x-tenant-id': tenantId,
        'x-is-registered-user': true,
        'x-user-id': customerId,
        'Content-Type': 'application/json',
    };
    try {
        const { response, status } = yield call(invokeApi, networkConfig.cancelPostOrder, { queryProps: { orderId: orderId } }, headers, paramData);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response) {
            yield put({
                type: CANCEL_POST_ORDER_SUCCESS,
                response,
            });
            successCallback && successCallback(response);
        }
        else {
            yield put({
                type: CANCEL_POST_ORDER_ERROR,
            });
            errorCallback && errorCallback();
        }
    }
    catch (error) {
        yield put({
            type: CANCEL_POST_ORDER_ERROR,
        });
        errorCallback && errorCallback();
    }
}
export function* cancelPostOrderSaga() {
    yield takeLatest(CANCEL_POST_ORDER, cancelPostOrderCall);
}
export function* checkInRequestCall(data) {
    const { payload, successCallback, errorCallback } = data;
    const { orderId, tenantId, customerId, paramData } = payload;
    const headers = {
        'x-tenant-id': tenantId,
        'x-is-registered-user': true,
        'x-user-id': customerId,
        'Content-Type': 'application/json',
    };
    try {
        const { response, status } = yield call(invokeApi, networkConfig.checkInRequest, { queryProps: { orderId: orderId } }, headers, paramData);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response) {
            yield put({
                type: CHECK_IN_REQUEST_SUCCESS,
                response,
            });
            successCallback && successCallback(response);
        }
        else {
            yield put({
                type: CHECK_IN_REQUEST_ERROR,
            });
            errorCallback && errorCallback();
        }
    }
    catch (error) {
        yield put({
            type: CHECK_IN_REQUEST_ERROR,
        });
        errorCallback && errorCallback();
    }
}
export function* checkInRequestSaga() {
    yield takeLatest(CHECK_IN_REQUEST, checkInRequestCall);
}
export function* addHopePaymentAccepted(data) {
    const { payload, successCallback, errorCallback } = data;
    const { tenantId, miscPaymentReferenceId } = payload;
    const headers = {
        'x-tenant-id': tenantId,
        'Content-Type': 'application/json',
    };
    try {
        const { response, status } = yield call(invokeApi, networkConfig.postAddHopePayment, { queryProps: { miscPaymentReferenceId: miscPaymentReferenceId } }, headers);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response) {
            yield put({
                type: ADD_HOPE_PAY_ACCEPTED_SUCCESS,
                response,
            });
            successCallback && successCallback(response);
        }
        else {
            yield put({
                type: ADD_HOPE_PAY_ACCEPTED_FAILURE,
            });
            errorCallback && errorCallback();
        }
    }
    catch (error) {
        yield put({
            type: ADD_HOPE_PAY_ACCEPTED_FAILURE,
        });
        errorCallback && errorCallback();
    }
}
export function* addHopePaymentAcceptedSaga() {
    yield takeLatest(ADD_HOPE_PAY_ACCEPTED, addHopePaymentAccepted);
}
export function* giftCardPurchase(data) {
    const { payload, successCallback, errorCallback } = data;
    const { tenantId, wiCodePurchaseId } = payload;
    const headers = {
        'x-tenant-id': tenantId,
        'Content-Type': 'application/json',
    };
    try {
        const { response, status } = yield call(invokeApi, networkConfig.postGiftCardPayment, { queryProps: { wiCodePurchaseId: wiCodePurchaseId } }, headers);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response) {
            yield put({
                type: GIFT_CARD_PURCHASE_SUCCESS,
                response,
            });
            successCallback && successCallback(response);
        }
        else {
            yield put({
                type: GIFT_CARD_PURCHASE_ERROR,
            });
            errorCallback && errorCallback();
        }
    }
    catch (error) {
        yield put({
            type: GIFT_CARD_PURCHASE_ERROR,
        });
        errorCallback && errorCallback();
    }
}
export function* giftCardPostPurchaseSaga() {
    yield takeLatest(GIFT_CARD_PURCHASE, giftCardPurchase);
}
